<template>
  <Loading :loading="loading" class=" pageContent container">
    <div class="row">
      <Breadcrumbs class="breadCrumbPadding"/>
    </div>
    <div v-if="memberBiz">
      <div class="row mt-3">
        <div class="col-12 backButton">
          <router-link
            class="btn btn-outline-primary"
            :to="{path: $route.params.backRoute}"
            v-if="'backName' in $route.params"
          >Back To {{$route.params.backName}}</router-link>
        </div>
        <h1 class="productTitle">{{memberBiz.title}}</h1>
      </div>
      <div class="row">
        <div class="col-12 col-md-4">
          <img
            v-if="memberBiz.images && memberBiz.images[0]"
            :src="imageUrl(memberBiz.images[0].sizes, 'large')"
            class="mw-100"
          >
        </div>
        <div class="col-12 col-md-8">
			<div v-html="memberBiz.description"></div>
			
			<div class="" v-if="memberBiz.product_url != ''">
			<a  :href="memberBiz.product_url" target="_blank" class="btn btn-green d-block d-md-inline-block my-3 mx-auto">
              View Website <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 27" width="24" height="24" fill="white" class="" style="padding: 2px;"><path data-v-5bea1272="" data-v-128d5e2e="" d="M5 3c-1.093 0-2 .907-2 2v14c0 1.093.907 2 2 2h14c1.093 0 2-.907 2-2v-7h-2v7H5V5h7V3H5zm9 0v2h3.586l-9.293 9.293 1.414 1.414L19 6.414V10h2V3h-7z" font-weight="400" font-family="sans-serif" overflow="visible" style="line-height: normal; text-indent: 0px; text-align: start; text-decoration-line: none; text-decoration-style: solid; text-decoration-color: rgb(0, 0, 0); text-transform: none; isolation: auto; mix-blend-mode: normal;"></path></svg></a>
			</div>
			
		</div>
      </div>
    </div>
    <div v-else class="col-9 text-center">
      Oops something went wrong, we can't find that Member Biz. Please try again, or go to our
      <router-link :to="{name:'home'}">Home Page</router-link>
    </div>
  </Loading>
</template>

<script>
//memberBiz are products just like brands so use this request to fetch them
import { fetchBrand } from "@/network/brandRequests";
import Loading from "@/components/loading/Loading";
import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs";

import { imageUrl } from "@/utils";

export default {
  name: "SingleMemberBiz",
  components: {
    Loading,
    Breadcrumbs
  },
  data() {
    return {
      memberBizData: null,
      loading: false
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    imageUrl,
    loadData() {
      this.loading = true;
      let bizId = this.$route.params.memberBiz;

      fetchBrand(
        bizId,
        result => {
          this.memberBizData = result;
          this.loading = false;
        },
        () => {
          //error
          this.loading = false;
        }
      );
    }
  },
  computed: {
    memberBiz() {
      if (this.memberBizData) {
        return this.memberBizData.product;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>

.backButton{
  padding: 20px 0;
}
.breadCrumbPadding{
  padding: 0;
}
@include media-breakpoint-up(md){
  .breadCrumbPadding{
    padding: 0 15px;
  }

  .backButton, .productTitle{
    padding: 20px 15px;
  }
}

</style>
